import React from "react";
import { Link } from "react-router-dom";
import { Star, ArrowRight } from "lucide-react";
import GhlReviewsWidget from "../GhlReviewsWidget";

const STAR_KEYS = ["s1", "s2", "s3", "s4", "s5"];

// Single source of reviews across the whole site: the embedded GoHighLevel
// Google reviews carousel (same widget used on the Reviews page), wrapped with
// our native fade-edge mask so it matches the rest of the design.
export default function ReviewsSection() {
  return (
    <section className="py-12 md:py-16 bg-[#F5F6F8] border-y border-slate-100" data-testid="home-reviews">
      <div className="abc-container">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-8">
          <div>
            <div className="text-xs font-bold uppercase tracking-widest text-[#54616E] mb-2">What customers say</div>
            <h2 className="font-display text-3xl sm:text-4xl font-extrabold text-[#1A1D21]">Reviews from across the Baltimore &amp; DC metros</h2>
          </div>
          <div className="flex items-center gap-0.5 text-[#E31D2B]">
            {STAR_KEYS.map((k) => <Star key={k} className="w-5 h-5 fill-[#E31D2B]" />)}
          </div>
        </div>
      </div>

      <div className="abc-container">
        <GhlReviewsWidget />
      </div>

      <div className="abc-container mt-8 text-center">
        <Link to="/reviews" className="abc-btn abc-btn-outline" data-testid="home-view-reviews">
          See all reviews <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
}
